/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DeleteProjectDailyTaskCommand } from '../../models/delete-project-daily-task-command';
import { DeleteProjectDailyTaskCommandResult } from '../../models/delete-project-daily-task-command-result';

export interface ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Params {
      body?: DeleteProjectDailyTaskCommand
}

export function apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete(http: HttpClient, rootUrl: string, params?: ApiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<DeleteProjectDailyTaskCommandResult>> {
  const rb = new RequestBuilder(rootUrl, apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete.PATH, 'delete');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DeleteProjectDailyTaskCommandResult>;
    })
  );
}

apiProjectDailyExpectedTasksDeleteProjectDailyTaskDelete.PATH = '/api/ProjectDailyExpectedTasks/DeleteProjectDailyTask';
